import React from 'react';
import { mustMoveCompanyLegalInfo } from '../lib/mustMoveCompanyLegalInfo';

interface BusinessInfoFooterProps {
    /** 변형: 'section'(기본, 독립된 푸터 섹션) | 'inline'(배경/경계 없이 컨텐츠만) */
    variant?: 'section' | 'inline';
    style?: React.CSSProperties;
}

const BusinessInfoFooter: React.FC<BusinessInfoFooterProps> = ({ variant = 'section', style }) => {
    const info = mustMoveCompanyLegalInfo;

    const isSection = variant === 'section';

    const outerStyle: React.CSSProperties = isSection
        ? {
              width: '100%',
              marginTop: 80,
              padding: '40px 20px 48px',
              background: 'transparent',
              fontFamily: "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
              ...style,
          }
        : {
              width: '100%',
              padding: '0 20px',
              fontFamily: "'Pretendard','Apple SD Gothic Neo',-apple-system,sans-serif",
              ...style,
          };

    return (
        <div style={outerStyle}>
            <div
                style={{
                    width: '100%',
                    maxWidth: 820,
                    margin: '0 auto',
                    textAlign: 'center',
                    fontSize: 12,
                    color: '#8A93A2',
                    lineHeight: 1.8,
                    letterSpacing: '-0.2px',
                }}
            >
                <div style={{ marginBottom: 8, fontWeight: 600, color: '#6B7280', fontSize: 13 }}>
                    {info.tradeName}
                </div>
                <div>
                    <span>상호명 : {info.officialTradeName}</span>
                    <span style={{ margin: '0 8px', color: '#D1D5DB' }}>|</span>
                    <span>대표자명 : {info.representativeName}</span>
                    <span style={{ margin: '0 8px', color: '#D1D5DB' }}>|</span>
                    <span>사업자등록번호 : {info.businessRegistrationNumber}</span>
                </div>
                <div>
                    <span>사업장 주소 : {info.address}</span>
                </div>
                <div>
                    <span>상점 전화번호 : {info.phone}</span>
                    <span style={{ margin: '0 8px', color: '#D1D5DB' }}>|</span>
                    <span>통신판매업 신고번호 : 제 {info.mailOrderSalesReportNumber}</span>
                </div>
            </div>
        </div>
    );
};

export default BusinessInfoFooter;
